import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export interface SubjectSearch {
  ask?: true;
  research?: true;
  inquiry?: string;
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function flag(value: unknown): boolean {
  return value === true || value === "1" || value === 1 || value === "true";
}

export function parseSubjectSearch(search: Record<string, unknown>): SubjectSearch {
  const inquiry = search["inquiry"];
  return {
    ...(flag(search["ask"]) ? { ask: true as const } : {}),
    ...(flag(search["research"]) ? { research: true as const } : {}),
    ...(typeof inquiry === "string" && UUID_RE.test(inquiry) ? { inquiry } : {}),
  };
}

export const subjectRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/subject/$subjectId",
  validateSearch: (search: Record<string, unknown>): SubjectSearch => parseSubjectSearch(search),
  component: lazyRouteComponent(() => import("./subject.page.js"), "SubjectRoutePage"),
});
